import corporateRequest from 'utils/corporateRequest'
import SuccessMessage from 'utils/SuccessMessage'
export const setDrivesDetails = data => {
  return {
    type: 'SET_DRIVES_DETAILS',
    data,
  }
}

export const getDriveDetails = (roleId,driveId)  => async (dispatch, getState) => {
    const state1 = getState()
    try {
        const res = await corporateRequest.get(
            `corporates/role/${roleId}/drive/${driveId}/student/${state1?.auth?.studentId}/interview`
        )
        dispatch(setDrivesDetails(res?.data?.data))
        console.log('drive data fetched successfully')
      } catch (error) {
        console.log('Error in Getting drive detail', error)
      }
    }


    export const DriveDateSelection = (driveID,payload) => async (dispatch, getState) => {
      try {
        const result = await corporateRequest.put(`corporate/drive/interview/${driveID}`, payload)
        if (result?.status === 201) {
          SuccessMessage('Date Requested Successfully')
        }
        return result
      } catch (error) {
        console.log('Error in Date Selection =>', error?.message)
        return error?.response
      }
    }

    export const ResheduleDriveDate = (driveID,roleID,payload) => async (dispatch, getState) => {
     
        const state1 = getState()
      try {
        const result = await corporateRequest.put(`corporates/role/${roleID}/drive/${driveID}/candidate/${state1?.auth?.studentId}`, payload)
        if (result?.status === 201) {
          SuccessMessage('Date Selected Successfully')
        }
        return result
      } catch (error) {
        console.log('Error in Date Selection =>', error?.message)
     
        return error?.response
      }
    
    }